import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import { slugify } from '../../helpers';
import { handleURLParams } from '../../helpers/URLParams';

const SelectGroup = (props) => {
  const {
    children,
    className,
    theme,
    cx,
    getStyles,
    Heading,
    label,
    data,
    setValue,
  } = props;

  const history = useHistory();

  const handleLabelClick = (e) => {
    e.preventDefault();
    setValue(`group-${slugify(label.toLowerCase()).replace('-', '')}-${data.search}`);
    handleURLParams({
      search: data.search,
      group: data.type,
    }, history);
  };

  return (
    <div
      // eslint-disable-next-line react/no-unknown-property
      css={getStyles('option', props)}
      className={cx(
        { group: true },
        className,
      )}
    >
      <Heading
        theme={theme}
        getStyles={getStyles}
        cx={cx}
        search={data.search}
        results={data.results}
        type={data.type}
        handleLabelClick={handleLabelClick}
      >
        {label}
      </Heading>
      <div>
        {children}
      </div>
    </div>
  );
};

SelectGroup.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  theme: PropTypes.object.isRequired,
  cx: PropTypes.func.isRequired,
  getStyles: PropTypes.func.isRequired,
  Heading: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  setValue: PropTypes.func.isRequired,
};

SelectGroup.defaultProps = {
  className: '',
};

export default SelectGroup;
